// import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from "react-redux";
// import { getReviewsFrontEnd} from "../../";




// const ClientTestimonials = () => {
//   const dispatch = useDispatch();


//     useEffect(() => {
//       dispatch(getReviewsFrontEnd());
//     }, [dispatch]);

//     const { getReviewsFrontEndData } = useSelector((state) => state.frontEndReducer);

//   const cardsPerView = window.innerWidth < 768 ? 1 : 2;
//   const maxIndex = testimonials.length - cardsPerView;

//   const handlePrev = () => {
//     setIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
//   };

//   const handleNext = () => {
//     setIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
//   };



//   return (
//     <div className="client-testimonials py-5 text-center">
//       <div className="container">
//         <h2 className="fw-bold mb-5">Clients’ experiences</h2>
//         <div className="testimonial-slider d-flex align-items-center justify-content-center position-relative">
//           <button className="arrow-btn left" onClick={handlePrev}>←</button>

//           <div className="testimonial-track d-flex">
//             {getReviewsFrontEndData.map((item, i) => (
//               <div key={i} className="testimonial-card shadow-sm mx-2 px-4 py-4"style={{ backgroundPositionX:"right", backgroundPositionY:"bottom"}}>
//                 <div className="quote-icon">“</div>
//                 <p className="testimonial-text">{item.discreapion}</p>
//                 <div className="d-flex align-items-center gap-3 mt-4">
//                   <div className="initials-circle">{item.initials}</div>
//                   <strong>{item.name}</strong>
//                 </div>
//               </div>
//             ))}
//           </div>

//           <button className="arrow-btn right" onClick={handleNext}>→</button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ClientTestimonials;




// const testimonials = [
//   {
//     name: "Ramesh Pawar",
//     initials: "RP",
//     feedback:
//       "I was hesitant to use a tax filing service, but I'm so glad I chose TaxnWealth. The team was very knowledgeable and walked me through the entire process step by step...",
//   },
//   {
//     name: "Vikram Mahajan",
//     initials: "VM",
//     feedback:
//       "The tax filing service provided swift solutions to errors with efficiency. Their promptness and meaningful communication ensured a satisfying experience...",
//   },
//   {
//     name: "Anita Desai",
//     initials: "AD",
//     feedback:
//       "Excellent support team and user-friendly interface. Filing taxes has never been this easy!",
//   },
//   {
//     name: "Sanjay Verma",
//     initials: "SV",
//     feedback:
//       "Quick, convenient, and professional. Highly recommended for stress-free tax filing.",
//   },
// ];





import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getReviewsFrontEnd } from "../../reducers/frontEndReducer";

const ClientTestimonials = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [index, setIndex] = useState(0);
  const [cardsPerView, setCardsPerView] = useState(window.innerWidth < 768 ? 1 : 2);

  const { getReviewsFrontEndData = [] } = useSelector((state) => state.frontEndReducer);

  useEffect(() => {
    dispatch(getReviewsFrontEnd());

    if (!localStorage.getItem("x-auth-token")) {
      navigate('/');
    }

    const handleResize = () => {
      setCardsPerView(window.innerWidth < 768 ? 1 : 2);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [dispatch, navigate]);

  const maxIndex = Math.max(0, getReviewsFrontEndData.length - cardsPerView);

  const handlePrev = () => {
    setIndex((prev) => (prev <= 0 ? maxIndex : prev - 1));
  };

  const handleNext = () => {
    setIndex((prev) => (prev >= maxIndex ? 0 : prev + 1));
  };



  return (
    <div className="client-testimonials py-5 text-center">
      <div className="container">
        <h2 className="fw-bold mb-5">Clients’ experiences</h2>
        <div className="testimonial-slider d-flex align-items-center justify-content-center position-relative">

          <button className="arrow-btn left" onClick={handlePrev}>←</button>

          <div className="testimonial-track d-flex">
            {getReviewsFrontEndData.length > 0 &&
              getReviewsFrontEndData.slice(index, index + cardsPerView).map((item, i) => {

                return (
                  <div
                    key={i}
                    className="testimonial-card shadow-sm mx-2 px-4 py-4"
                    style={{ backgroundPositionX: "right", backgroundPositionY: "bottom" }}
                  >
                    <div className="quote-icon">“</div>
                    <p className="testimonial-text">{item.description}</p>
                    <div className="d-flex align-items-center gap-3 mt-4">
                      <div className="initials-circle">
                        {`${item.user?.firstName?.charAt(0).toUpperCase() || ''}${item.user?.lastName?.charAt(0).toUpperCase() || ''}`}
                      </div>
                      <h4> <strong>{`${item.user.firstName} ${item.user.lastName}`}</strong></h4>
                    </div>

                  </div>
                );
              })}
          </div>


          <button className="arrow-btn right" onClick={handleNext}>→</button>
        </div>
      </div>
    </div>
  );
};

export default ClientTestimonials;


